import {
    PricingItemUpdateAction,
    QuoteUpdateAction,
    ReferentialCreateAction,
    ReferentialServicesCreateAction,
    QuoteActions,
    QuoteActionTypes,
    HydrateQuoteSuccess
} from './quote.actions';
import {QuoteWrapper} from '../../models/quote/quote-wrapper';
import {QuoteService} from '../../models/quote/quote-service';
import {CustomGroup} from '../../models/quote/group/custom-group';
import {EnumQuoteServiceSalesType} from '../../models/enum/enum-quote-service-sales-type';
import {ServiceLine} from '../../models/quote/service-line';
import {EPPClientPrototypeMapper} from '../../utils/EPPClientPrototypeMapper';
import {cloneDeep} from 'lodash-es';

export class QuoteState {
    wrapper: QuoteWrapper;
    referential: any;
    referentialServices: any;
}

const wrapperMock = new QuoteWrapper();

export const quoteInitialState: QuoteState = {
    wrapper: wrapperMock,
    referential: {},
    referentialServices: []
};

function getQuoteServiceBySalesType(newServiceLine: ServiceLine, salesType: EnumQuoteServiceSalesType) {
    switch (salesType) {
        case EnumQuoteServiceSalesType.NEW:
            return newServiceLine.newQuoteService;
        case EnumQuoteServiceSalesType.EXISTING:
            return newServiceLine.existingQuoteService;
        case EnumQuoteServiceSalesType.RENEWAL:
            return newServiceLine.renewalQuoteService;
    }

}

export function quoteReducer(state: QuoteState, action: QuoteActions): QuoteState {
    function getServiceLineIndex(codeService: string) {
        return state.wrapper.serviceLines.findIndex(element =>
            element.code === codeService
        );
    }

    function getCustomGroup(newServices: QuoteService, articleId: string) {
        return newServices.customGroups.find(customGroup =>
            customGroup.pricingItems.find(pricingItem => pricingItem.id === articleId));
    }

    function updateServiceLineWithQuoteService(salesType: EnumQuoteServiceSalesType, newServiceLines: ServiceLine[], serviceLineIndex: number, newQuoteService: QuoteService): ServiceLine[] {
        let serviceLines = [...newServiceLines];
        switch (salesType) {
            case EnumQuoteServiceSalesType.NEW:
                serviceLines[serviceLineIndex] = newServiceLines[serviceLineIndex].copyWith({
                    newQuoteService: newQuoteService
                });
                break;
            case EnumQuoteServiceSalesType.EXISTING:
                serviceLines[serviceLineIndex] = newServiceLines[serviceLineIndex].copyWith({
                    existingQuoteService: newQuoteService
                });
                break;
            case EnumQuoteServiceSalesType.RENEWAL:
                serviceLines[serviceLineIndex] = newServiceLines[serviceLineIndex].copyWith({
                    renewalQuoteService: newQuoteService
                });
                break;
        }
        return serviceLines;
    }

    switch (action.type) {
        case QuoteActionTypes.HYDRATE_QUOTE_STORE_SUCCESS:
            const quotestate = (action as HydrateQuoteSuccess).payload

            if(quotestate) {
                const quoteStateWithPrototype = setUserStatePrototypes(quotestate)
                console.log('[Quote] Hydration Success', quoteStateWithPrototype);
                return quoteStateWithPrototype;
            }
            return quoteInitialState;
        case QuoteActionTypes.QUOTE_UPDATE_SUCCESS:
            console.log('QUOTE_UPDATE_SUCCESS_ACTION');
            const quote = (action as QuoteUpdateAction).payload.wrapper;
            return Object.assign({}, state, {
                wrapper: quote
            });
        case QuoteActionTypes.PRICING_ITEM_VALIDATE_ACTION: {
            const newPricingItem = (action as PricingItemUpdateAction).payload.pricingItem;
            const codeService = (action as PricingItemUpdateAction).payload.codeService;
            const salesType = (action as PricingItemUpdateAction).payload.salesType;


            let newServiceLines = [...state.wrapper.serviceLines];
            let serviceLineIndex = getServiceLineIndex(codeService);
            let newQuoteService = getQuoteServiceBySalesType(newServiceLines[serviceLineIndex], salesType);
            let customGroup = getCustomGroup(newQuoteService, newPricingItem.id);

            if (customGroup !== undefined) {
                let newPricingItems = [...customGroup.pricingItems];
                const articleIndex = newPricingItems.findIndex(element => element.id == newPricingItem.id);
                newPricingItems[articleIndex] = newPricingItem;

                let newCustomGroups = newQuoteService.customGroups.map(_customGroup => {
                    if (_customGroup.id === customGroup.id) {
                        return new CustomGroup().copyWith({
                            id: customGroup.id,
                            title: customGroup.title,
                            order: customGroup.order,
                            pricingItems: newPricingItems,
                            isDuplicated: customGroup.isDuplicated,
                            totalAppliedPrice: customGroup.totalAppliedPrice
                        });
                    }
                    return _customGroup;
                });

                newQuoteService = newQuoteService.copyWith({customGroups: newCustomGroups});

                return Object.assign({}, state, {
                    wrapper: state.wrapper.copyWith({
                        serviceLines: updateServiceLineWithQuoteService(salesType, newServiceLines, serviceLineIndex, newQuoteService)
                    })
                });
            }
            return state;
        }
        case QuoteActionTypes.CREATE_REFERENTIAL_ACTION:
            console.log('CREATE_REFERENTIAL_ACTION');
            const referential = (action as ReferentialCreateAction).payload.referential;
            return Object.assign({}, state, {referential: referential});
        case QuoteActionTypes.CREATE_REFERENTIAL_SERVICES_ACTION:
            console.log('CREATE_REFERENTIAL_SERVICES_ACTION');
            const referentialServices = (action as ReferentialServicesCreateAction).payload.referentialServices;
            return Object.assign({}, state, {referentialServices: referentialServices});
    }
    return state;
}

export const setUserStatePrototypes = function(state: QuoteState) {
    let newUserState: QuoteState = Object.setPrototypeOf(cloneDeep(state), QuoteState.prototype);
    newUserState.wrapper = EPPClientPrototypeMapper.setQuoteWrapperPrototype(newUserState.wrapper);
    return newUserState;
};
